<template>
  <div class="page-editor">
    <mt-header fixed title="经销商信息">
      <router-link to="/ent/dealer" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <mt-field label="经销商名称" readonly v-model="dealerInfo.name"></mt-field>
    <mt-field label="联系人" readonly v-model="dealerInfo.linkman"></mt-field>
    <mt-field label="联系电话" readonly v-model="dealerInfo.telephone"></mt-field>
    <mt-field label="联系地址" readonly v-model="dealerInfo.address" type="textarea" rows="3"></mt-field>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import { Toast, Cell, Button, Field, Header } from "mint-ui";

export default {
  props: ["dealerId"],
  components: {Toast, Cell, Button, Field, Header},
  data: function() {
    return {
      dealerInfo: {
        name: null,
        linkman: null,
        telephone: null,
        address: null
      }
    };
  },
  mounted: function() {
    if(this.dealerId){
      this.$http.get(this.GLOBAL.serverUrl + "/ent/dealer/" + this.dealerId).then(resp => {
        if (resp.body.code == 200) 
          this.dealerInfo = resp.body.data;
        else if (resp.body.code == 500) 
          Toast("获取数据失败，请稍后再试！");
      });
    }
  }
};
</script>
<style scoped>
.page-editor {
  padding-top: 40px;
}
</style>